import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { useSensitiveCommunitiesContext } from 'src/contexts/sensitive-communities.context';
import { actionTypes } from 'src/ducks/sensitive-communities.duck';
import { ISensitiveCommunities, ISensitiveCommunitiesForm } from 'src/models/sensitive-communities.model';
import { getSensitiveCommunitiesStatus } from 'src/selectors/sensitive-communities.selector';
import SensitiveCommunitiesForm from '../sensitive-communities-form/sensitive-communities-form.component';
import style from '../sensitive-communities-list/sensitive-communities-list.module.scss';

const SensitiveCommunitiesAdd: React.FC = () => {
  const { state, actions } = useSensitiveCommunitiesContext();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const defaultValues: Partial<ISensitiveCommunities> = {
    sensitiveCommunity: '',
    sensitiveCommunityPamLead: '',
  };

  const addStatus = getSensitiveCommunitiesStatus(state, actionTypes.SENSITIVE_COMMUNITIES_ADD);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (data) => {
      const formData: ISensitiveCommunitiesForm = {
        sensitiveCommunity: data.sensitiveCommunity,
        sensitiveCommunityPamLead: data.sensitiveCommunityPamLead,
      };
      const response = await actions.addPOST(formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_SENSITIVE_COMMUNITY_ADD_SUCCESS,
            formData.sensitiveCommunity ? formData.sensitiveCommunity : data.sensitiveCommunity
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsAddOpen(false);
      actions.listGET();
    },
    [actions, setIsAddOpen]
  );

  return (
    <ATMModal
      open={isAddOpen}
      size="tiny"
      trigger={
        <ATMButton
          basic
          color="blue"
          content={Lang.LBL_NEW}
          icon="plus"
          floated="right"
          onClick={() => setIsAddOpen(true)}
        />
      }
      header={Lang.LBL_ADD_SENSITIVE_COMMUNITIES}
      content={
        <div className={style.content}>
          <SensitiveCommunitiesForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsAddOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || addStatus.fetching}
            onClick={handleSave}
            loading={addStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default SensitiveCommunitiesAdd;
